import React, { useState } from "react";
import Swal from "sweetalert2";
import { contactsocail } from "../../constants/contact";
import { Link } from "react-router-dom";

const Contact = () => {
  const [result, setResult] = useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending...");

    const formData = new FormData(event.target);
    formData.append("access_key", "0e5bee4a-1264-4666-bb43-8d4cba775c99");

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.success) {
        await Swal.fire({
          title: "Success!",
          text: "Your email has been sent successfully!",
          icon: "success",
          background: "#1e293b", // Matches dark theme
          color: "#fff",
        });
        event.target.reset();
      } else {
        await Swal.fire({
          icon: "error",
          title: "Oops...",
          text: data.message || "Message could not be sent!",
          background: "#1e293b",
          color: "#fff",
        });
      }
    } catch (error) {
      await Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.message || "Messages cannot be sent!",
        background: "#1e293b",
        color: "#fff",
      });
    } finally {
      setResult("");
    }
  };

  return (
    <div className="contact-page-container">
      {/* Background blobs for glass refraction */}
      <div className="glass-blob blob-1"></div>
      <div className="glass-blob blob-2"></div>

      <div className="contact-content-wrapper">
        {/* Left Column */}
        <div className="contact-left mt-5">
          <h1 className="contact-title">Get In Touch</h1>
          <p className="contact-desc">
            I’m always open to discussing new projects, creative ideas, or
            opportunities to collaborate. Let’s connect and build something
            amazing together!
          </p>

          <div className="contact-social-icons">
            {contactsocail.map((item, index) => (
              <Link key={index} to={item.url} target="_blank" rel="noreferrer">
                <img
                  src={item.logo}
                  alt="social logo"
                  className="contact-social-logo"
                />
              </Link>
            ))}
          </div>
        </div>

        {/* Right Column - Contact Form */}
        <div className="contact-right">
          <div className="contact-form-box">
            <h2 className="contact-form-title">Contact Me</h2>
            <form className="contact-form" onSubmit={onSubmit}>
              <div className="contact-input-box">
                <label>Full Name</label>
                <input
                  type="text"
                  name="name"
                  className="contact-field"
                  placeholder="Enter Your Name"
                  required
                />
              </div>

              <div className="contact-input-box">
                <label>Email Address</label>
                <input
                  type="email"
                  name="email"
                  className="contact-field"
                  placeholder="Enter Your Email"
                  required
                />
              </div>

              <div className="contact-input-box">
                <label>Your Message</label>
                <textarea
                  name="message"
                  className="contact-field contact-message"
                  placeholder="Write your message here"
                  required
                />
              </div>

              <div className="text-center mt-4">
                <button
                  type="submit"
                  className="contact-btn-submit"
                  disabled={result === "Sending..."}
                >
                  {result === "Sending..." ? "Sending..." : "Send Message"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
